import { useTenantProfile } from 'hooks/api/tenant/useTenantProfile'
import Text from 'components/common/Text'
import { Container, Row, Col } from 'react-bootstrap'
import { IconRow } from './components/IconRow'
import PartnerSignup from 'assets/backgrounds/PartnerSignup.jpg'

export const WhatYouGainBlock = () => {
	const { data: tenantProfile } = useTenantProfile()
	const tenantName = tenantProfile?.name
	const secondaryColor = tenantProfile?.theme?.secondaryColor

	return (
		<Container style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
			<div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
				<Row>
					<Col>
						<Text
							size={34}
							style={{
								fontWeight: 'bold',
								textAlign: 'center',
							}}
						>
							What you gain by signing up...
						</Text>
					</Col>
				</Row>
			</div>

			<Row>
				<Col xs={12} md={6} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
					<IconRow icon={'dollar-sign'} title={'Save Time'}>
						<Text>Help your clients save money on their annual property tax bill.</Text>
					</IconRow>
					<IconRow icon={'megaphone'} title={'Stay Top of Mind'}>
						<Text>
							Share your <span style={{ color: secondaryColor }}>{tenantName}</span> referral link
							to stay top of mind in between transactions while you help clients save money.
						</Text>
					</IconRow>
					<IconRow icon={'handshake'} title={'Build Lasting Trust'}>
						<Text>
							Remain a trusted resource throughout your clients' homeownership experience.
						</Text>
					</IconRow>
					<IconRow icon={'chart-line'} title={'Grow Referrals & Leads'}>
						<Text>
							Expand your network when your clients refer their friends and neighbors to your
							personalized <span style={{ color: secondaryColor }}>{tenantName}</span> page.
						</Text>
					</IconRow>
				</Col>
				<Col
					xs={12}
					md={{ span: 4, offset: 1 }}
					lg={{ span: 3, offset: 2 }}
					className={'d-none d-md-block'}
					style={{ display: 'flex', flex: 1, alignItems: 'flex-end' }}
				>
					<img src={PartnerSignup} style={{ width: '100%', height: 'auto' }} />
				</Col>
			</Row>
		</Container>
	)
}
